/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { DeleteUploadMutationResponse, DeleteUploadPathParams } from "../models/DeleteUpload";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteUpload } from "../axios/deleteUpload";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteUploadMutationKey = () => ["social-export-api", { url: '/upload/:id' }] as const

export type DeleteUploadMutationKey = ReturnType<typeof deleteUploadMutationKey>

export function deleteUploadMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteUploadMutationKey()
        return mutationOptions<DeleteUploadMutationResponse, ResponseErrorConfig<Error>, {id: DeleteUploadPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return deleteUpload(id, config)
          },
        })

}

/**
 * @summary Delete video from platform
 * {@link /upload/:id}
 */
export function useDeleteUpload<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteUploadMutationResponse, ResponseErrorConfig<Error>, {id: DeleteUploadPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteUploadMutationKey()

          const baseOptions = deleteUploadMutationOptions(config) as UseMutationOptions<DeleteUploadMutationResponse, ResponseErrorConfig<Error>, {id: DeleteUploadPathParams["id"]}, TContext>
          

          return useMutation<DeleteUploadMutationResponse, ResponseErrorConfig<Error>, {id: DeleteUploadPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteUploadMutationResponse, ResponseErrorConfig<Error>, {id: DeleteUploadPathParams["id"]}, TContext>
      
}